import { mergeAll } from 'lodash/fp'

import mediaSummaryActions from './actions/mediaSummary.actions'

export default mergeAll([mediaSummaryActions])
